import { Card } from "@/components/ui/card";

// Real, honest placeholder for a nav destination whose business logic isn't
// built yet — no demo/fake data, ever. `note` may include real counts the
// caller already fetched; it must never be invented content.
export default function ComingSoon({ icon: Icon, title, description, note }) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl">{title}</h1>
        {description && <p className="text-slate-400 mt-1 text-sm">{description}</p>}
      </div>
      <Card className="p-10 bg-[#131924] border-[#212b3d] text-center text-slate-500">
        {Icon && <Icon className="mx-auto mb-3 opacity-50" size={32} />}
        <div className="text-slate-300 font-medium mb-1">Раздел в разработке</div>
        {note && <div className="text-sm max-w-md mx-auto">{note}</div>}
      </Card>
    </div>
  );
}
